import * as t from './actionTypes';
import { fetchUserProjectResponse } from './actions';
import type { InitialUserContextReduxState } from './types';

export const initialState = {
  // setting this to true so the gdpr banner doesn't flash on the initial load of the app.
  isGdprAccepted: true,
  featureFlags: {},
  isLoaded: false,
};

const userContextReducer = (
  state: InitialUserContextReduxState = initialState,
  action: ReturnType<typeof fetchUserProjectResponse>,
) => {
  switch (action?.type) {
    case t.FETCH_USER_CONTEXT_RESPONSE:
      return {
        ...state,
        ...action.response,
        isLoaded: true,
      };
    default: {
      return state;
    }
  }
};

export default userContextReducer;
